import styled from 'styled-components'
import { Colors, StackChildren, Text } from '@doordash/design-language'

export const ErrorPageContainer = styled.div`
  height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Center = styled(StackChildren)`
  display: flex;
  align-items: center;
  text-align: center;
  flex-direction: column;
  max-width: 50%;
`

export const TextLink = styled(Text)`
  color: ${Colors.TextLink};
  text-decoration: underline;
  cursor: pointer;
`